import React,{ useState, useEffect } from 'react';
import Breadcrumbs from './Breadcrumbs';
import Sercontent from './sercontent';

const Services = () => {
    const [state, setstate] = useState([]);
    const getData = async () =>{
        try{
            const res = await fetch("https://jsonplaceholder.typicode.com/comments");
            setstate(await res.json())


        }
        catch(err){
            console.log(err);
        }
    }
    useEffect(() => {
        getData();
    }, [])
    return (
        <>
        <Breadcrumbs name="Our Services" linename="Service"/>
           <Sercontent state = {state}/>

  
        </>
    )
}

export default Services;
